<template>
<div>
  <CenterizedTile @click="dialog=true">
    <IconifiedTile>
      <template #icon>
        <v-icon size="60" :color="color">{{ clickIcon }}</v-icon>
      </template>
      <template #value>{{ clickState }}</template>
      <template #title>{{ config.name || $t(`type.${info.type}`) }}</template>
    </IconifiedTile>
  </CenterizedTile>
  <ButtonHistoryDialog v-if="dialog" v-model="dialog" :device="device" :endpoint="endpointId" @setting="showSettingsDialog"></ButtonHistoryDialog>
</div>
</template>

<script>
import EndpointTile from '@/components/tile/EndpointTile'
import CenterizedTile from '@/components/tile/CenterizedTile'
import IconifiedTile from '@/components/tile/IconifiedTile'
import ButtonHistoryDialog from '@/components/history/ButtonHistoryDialog'

export default {
  name: 'ButtonTile',
  mixins: [EndpointTile],
  components: {
    CenterizedTile,
    IconifiedTile,
    ButtonHistoryDialog
  },
  computed: {
    clickState() {
      return this.report.clickState ? this.$t(`button.${this.report.clickState}`) : '---';
    },
    clickIcon() {
      switch (this.report.clickState) {
        case 'DOUBLE':
        case 'TRIPLE':
          return 'mdi-gesture-double-tap';
        case 'LONG':
          return 'mdi-gesture-tap-hold';
        default:
          return 'mdi-gesture-tap';
      }
    },
    color() {
      return this.report.clickState != undefined ? 'primary' : 'color';
    }
  }
}
</script>
